import { useQueryClient } from "@tanstack/react-query";

import { profileKeys } from "./query_keys";

export const useCurrentProfileSet = () => {
  const queryClient = useQueryClient();

  return (profile) => queryClient.setQueryData(profileKeys.me(), profile);
};
